// redux
import { applyMiddleware, compose, createStore } from 'redux';
import createSagaMiddleware from 'redux-saga';
// import { persistStore, persistReducer } from 'redux-persist';
// import hardSet from 'redux-persist/lib/stateReconciler/hardSet';
// import storage from 'redux-persist/lib/storage'; // defaults to localStorage for web
import rootReducer from './rootReducer';

// Sagas (A model for redux side-effects)
import initSagas from './rootSaga';
import { isTestEnvironment } from '../library/settings/environmentSettings';

// redux first routing - Puts redux in charge of url state

const sagaMiddleware = createSagaMiddleware();

// const persistConfig = {
//   key: 'root',
//   storage,
//   blacklist: ['router'],
//   stateReconciler: hardSet,
// };

// const logger = store => next => action => {
//   console.log('dispatching', action);
//   const result = next(action);
//   console.log('next state', store.getState());
//   return result;
// };

const configureStore = (middleware = [], initialState = {}) => {
  const middlewareEnhancer = applyMiddleware(sagaMiddleware, ...middleware);

  const composeEnhancers =
    typeof window === 'object' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ // eslint-disable-line
      ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
          // eslint-disable-line
          // Specify extension’s options like name, actionsBlacklist, actionsCreators, serialize...
        })
      : compose;

  const enhancers = composeEnhancers(middlewareEnhancer);

  // const persistedReducer = persistReducer(persistConfig, rootReducer);

  const store = createStore(rootReducer, initialState, enhancers);
  if (isTestEnvironment()) {
    window.store = store;
  }
  // const persistor = persistStore(store);
  // persistor.purge()

  initSagas(sagaMiddleware);

  if (process.env.NODE_ENV === 'development') {
    if (module.hot) {
      module.hot.accept('./rootReducer', () => {
        // eslint-disable-next-line
        store.replaceReducer(require('./rootReducer').default);
      });

      // We could do saga replacement here, but there are caveats
      // See: https://github.com/redux-saga/redux-saga/issues/22#issuecomment-218737951
      // So, we'll just reload the whole app.
    }
  }

  return {
    store,
    // persistor,
  };
};

export default configureStore;
